<template>
  <v-autocomplete
    v-bind="{...defaults, ...$attrs}"
    class="ol-autocomplete"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <slot />
  </v-autocomplete>
</template>

<script>
export default {
  name: 'OlAutocomplete',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {
      filled: true,
      'background-color': 'white'
    }
  }
}
</script>
